"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDropdown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _v = _interopRequireDefault(require("uuid/v4"));

var _isTriggeredInside = require("../../skybase-core/utils/is-triggered-inside");

var _constants = require("../sb-select-option/constants");

var _sbDropdownOption = require("./sb-dropdown-option");

var _sbDropdownGroup = require("./sb-dropdown-group");

var _sbDropdownHeader = require("./sb-dropdown-header");

var _sbSelectOption = require("../sb-select-option");

var _shapes = require("./shapes");

var _constants2 = require("./constants");

var _shapes2 = require("../sb-select-option/shapes");

var _value = require("../../skybase-core/utils/value");

var _utils = require("./utils");

var _utils2 = require("../sb-select-option/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AUTO_TOP = _constants2.menuPositions.AUTO_TOP,
    AUTO_BOTTOM = _constants2.menuPositions.AUTO_BOTTOM,
    AUTO = _constants2.menuPositions.AUTO,
    BOTTOM_RIGHT = _constants2.menuPositions.BOTTOM_RIGHT;

var SbDropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(SbDropdown, _PureComponent);

  var _super = _createSuper(SbDropdown);

  function SbDropdown(props) {
    var _this;

    _classCallCheck(this, SbDropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var opened = _this.state.opened; // if this event was triggered inside of our component, ignore it

      if (event && (0, _isTriggeredInside.isTriggeredInside)(_this.node, event) || // triggered inside menu
      event.target && typeof event.target.className === 'string' && event.target.className.indexOf(_constants2.AUTOCOMPLETE_ICON_CLOSE) !== -1 // triggered by X button
      ) {
          _this.handleOnFocus();

          return;
        }

      if (opened) {
        _this.setState({
          opened: false
        });
      }

      _this.handleOnBlur();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnDropdownButtonClick", function (event) {
      event.preventDefault();
      var onClick = _this.props.buttonProps.onClick;

      _this.setState(function (prevState) {
        return {
          opened: !prevState.opened
        };
      });

      if (onClick) {
        onClick(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (value) {
      var onChange = _this.props.onChange;

      if (_this.getMode() === _constants.MODE.RADIO) {
        _this.setState({
          opened: false
        });
      }

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var isFocused = _this.state.isFocused;
      var onBlur = _this.props.onBlur;

      if (isFocused) {
        _this.setState({
          isFocused: false
        }, function () {
          onBlur();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function () {
      var isFocused = _this.state.isFocused;
      var onFocus = _this.props.onFocus;

      if (!isFocused) {
        _this.setState({
          isFocused: true
        }, function () {
          onFocus();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "setDisplayedTextWidth", function (node) {
      if (node) {
        _this.setState({
          displayedTextWidth: node.offsetWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getMode", function () {
      var _this$props = _this.props,
          modeProp = _this$props.mode,
          multiSelect = _this$props.multiSelect;
      var mode = modeProp;

      if (!(0, _value.isNullOrUndefined)(multiSelect)) {
        mode = multiSelect ? _constants.MODE.CHECKBOX : _constants.MODE.RADIO;
      }

      return mode;
    });

    _defineProperty(_assertThisInitialized(_this), "renderDropdownButton", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          selected = _this$props2.selected,
          title = _this$props2.title,
          children = _this$props2.children,
          items = _this$props2.items,
          buttonProps = _this$props2.buttonProps,
          customBody = _this$props2.customBody;
      var _this$state = _this.state,
          displayedTextWidth = _this$state.displayedTextWidth,
          opened = _this$state.opened;
      var dropdownIconClass = opened && !disabled ? _constants2.AUTOCOMPLETE_ICON_HIDE_MENU : _constants2.AUTOCOMPLETE_ICON_SHOW_MENU;
      var headerOptions = (items === null || items === void 0 ? void 0 : items.length) ? items : children;

      var className = buttonProps.className,
          type = buttonProps.type,
          rest = _objectWithoutProperties(buttonProps, ["className", "type"]);

      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/button-has-type
        _react.default.createElement("button", _extends({}, rest, {
          disabled: disabled,
          type: type !== null && type !== void 0 ? type : 'button',
          onClick: _this.handleOnDropdownButtonClick,
          className: (0, _classnames.default)(className, {
            opened: opened
          })
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-dropdown-inner"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-dropdown-text",
          ref: _this.setDisplayedTextWidth
        }, /*#__PURE__*/_react.default.createElement(_sbDropdownHeader.SbDropdownHeader, {
          selected: selected,
          options: headerOptions,
          title: title,
          displayedTextWidth: displayedTextWidth,
          mode: _this.getMode(),
          id: _this.id,
          customBody: customBody
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "sb-dropdown-icon"
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: dropdownIconClass
        }))))
      );
    });

    _this.id = (0, _v.default)();
    _this.state = {
      displayedTextWidth: null,
      opened: false,
      isFocused: false
    };
    return _this;
  }

  _createClass(SbDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _sizes$size,
          _this2 = this,
          _menuProps$style;

      var _this$props3 = this.props,
          children = _this$props3.children,
          id = _this$props3.id,
          className = _this$props3.className,
          size = _this$props3.size,
          disabled = _this$props3.disabled,
          open = _this$props3.open,
          menuPosition = _this$props3.menuPosition,
          liveSearch = _this$props3.liveSearch,
          menuProps = _this$props3.menuProps,
          selected = _this$props3.selected,
          hasError = _this$props3.hasError,
          items = _this$props3.items,
          multiSelect = _this$props3.multiSelect,
          buttonProps = _this$props3.buttonProps,
          maxHeight = _this$props3.maxHeight,
          minHeight = _this$props3.minHeight,
          height = _this$props3.height,
          minimumSearchLetters = _this$props3.minimumSearchLetters,
          style = _this$props3.style,
          title = _this$props3.title,
          mode = _this$props3.mode,
          placeholder = _this$props3.placeholder,
          onBlur = _this$props3.onBlur,
          onFocus = _this$props3.onFocus,
          customBody = _this$props3.customBody,
          rest = _objectWithoutProperties(_this$props3, ["children", "id", "className", "size", "disabled", "open", "menuPosition", "liveSearch", "menuProps", "selected", "hasError", "items", "multiSelect", "buttonProps", "maxHeight", "minHeight", "height", "minimumSearchLetters", "style", "title", "mode", "placeholder", "onBlur", "onFocus", "customBody"]);

      var opened = this.state.opened;
      var isOpened = open !== null && open !== void 0 ? open : opened;
      var sizeClass = (_sizes$size = _constants2.sizes[size]) !== null && _sizes$size !== void 0 ? _sizes$size : _constants2.sizes.m;
      var classes = (0, _classnames.default)('sb-dropdown', {
        disabled: disabled
      }, className, sizeClass);
      var dropdownId = id !== null && id !== void 0 ? id : this.id;
      var menuRealPosition = menuPosition;

      if (menuPosition === AUTO || menuPosition === AUTO_TOP || menuPosition === AUTO_BOTTOM) {
        if (customBody) {
          menuRealPosition = BOTTOM_RIGHT;
        } else {
          var itemsToCalculate = items; // json structure that is needed for further calculation

          if (!(items === null || items === void 0 ? void 0 : items.length) && children) {
            itemsToCalculate = (0, _utils2.convertComponentsToArray)(_react.default.Children.toArray(children)); // when there are children defined and items undefined
          }

          var _calculateSpaceForMen = (0, _utils.calculateSpaceForMenu)({
            node: this.node,
            items: itemsToCalculate,
            maxHeight: maxHeight
          }),
              canFitTop = _calculateSpaceForMen.canFitTop,
              canFitBottom = _calculateSpaceForMen.canFitBottom;

          menuRealPosition = (0, _utils.decideMenuPosition)({
            canFitBottom: canFitBottom,
            canFitTop: canFitTop,
            menuPosition: menuPosition
          });
        }
      }

      var menuID = "dropdown-".concat(dropdownId);
      return /*#__PURE__*/_react.default.createElement("div", _extends({}, rest, {
        style: style,
        id: dropdownId,
        className: classes,
        ref: function ref(node) {
          _this2.node = node;
        },
        role: "combobox",
        "aria-expanded": isOpened,
        "aria-haspopup": "listbox",
        "aria-controls": menuID
      }), this.renderDropdownButton(), isOpened && /*#__PURE__*/_react.default.createElement(_sbSelectOption.SbSelectGeneral, _extends({}, menuProps, {
        placeholder: placeholder,
        selected: selected,
        onChange: this.handleOnChange,
        componentType: _constants.COMPONENT_TYPE.DROPDOWN,
        id: menuID,
        menuPositionClass: (0, _classnames.default)({
          opened: isOpened
        }, "menu-position-".concat(menuRealPosition)),
        mode: this.getMode(),
        liveSearch: liveSearch,
        hasError: hasError,
        items: items,
        style: (_menuProps$style = menuProps.style) !== null && _menuProps$style !== void 0 ? _menuProps$style : {},
        maxHeight: maxHeight,
        minHeight: minHeight,
        height: height,
        customBody: customBody
      }), children));
    }
  }]);

  return SbDropdown;
}(_react.PureComponent);

exports.SbDropdown = SbDropdown;

_defineProperty(SbDropdown, "propTypes", _objectSpread(_objectSpread({}, _shapes2.restPropsGeneralShape), {}, {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  mode: _propTypes.default.string,
  onChange: _propTypes.default.func,
  menuPosition: _shapes.menuPositionShape,
  multiSelect: _propTypes.default.bool,
  // backward-compatibility
  liveSearch: _propTypes.default.bool,
  menuProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  buttonProps: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  size: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  customBody: _propTypes.default.bool
}));

_defineProperty(SbDropdown, "defaultProps", _objectSpread(_objectSpread({}, _shapes2.restPropsGeneralDefaults), {}, {
  className: null,
  id: null,
  mode: _constants.MODE.RADIO,
  onChange: _constants.NOOP,
  multiSelect: null,
  menuPosition: AUTO,
  liveSearch: false,
  menuProps: {},
  buttonProps: {},
  size: _constants2.sizes.m,
  placeholder: null,
  onBlur: _constants.NOOP,
  onFocus: _constants.NOOP,
  customBody: false
}));

_defineProperty(SbDropdown, "Option", _sbDropdownOption.SbDropdownOption);

_defineProperty(SbDropdown, "Divider", _sbSelectOption.SbSelectDivider);

_defineProperty(SbDropdown, "Group", _sbDropdownGroup.SbDropdownGroup);
//# sourceMappingURL=sb-dropdown.js.map